import './index.css'

export const Skills = () => {


    return (

        <div className="skills-section">


            <p>C++/C#</p>
            <div className="skill-container">
                <div className="skill cs">60%</div>
            </div>
            <p>UI Designing</p>
            <div className="skill-container">
                <div className="skill ui">70%</div>
            </div>

            <p>Animation</p>
            <div className="skill-container">
                <div className="skill ani">65%</div>
            </div>
            <p>Graphics Designing</p>
            <div className="skill-container">
                <div className="skill gd">80%</div>
            </div>
            <p>3D Modelling</p>
            <div className="skill-container">
                <div className="skill modelling">70%</div>
            </div>

        </div>
    )

}